import React from 'react';
import classnames from 'classnames';
import { withStyles } from '@glu/theming';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import dialogActions from 'core/dialogs/actions';
import Grid from 'fields/Grid';
import Button from 'common/Button';
import dialogStyles from './styles/dialog';
import contentWrapperStyles from './styles/contentWrapper';
import contentStyles from './styles/content';
import headerStyles from './styles/header';
import titleStyles from './styles/title';
import bodyStyles from './styles/body';
import footerStyles from './styles/footer';

const styles = (theme) => {
  const common = {
    body: bodyStyles(theme),
    content: {
      ...contentStyles(theme),
      display: 'flex',
    },
    contentWrapper: contentWrapperStyles(theme),
    dialog: dialogStyles(theme),
    footer: footerStyles(theme),
    header: headerStyles(theme),
    title: titleStyles(theme),
  };
  return common;
};

const Rates = ({ classes, close, commonClasses, fieldRates, gridLabel }) => (
  <div className={classnames('dialog-rates', commonClasses, classes.dialog)}>
    <form className={classnames('modal-content', classes.content)}>
      <div className={classnames('modal-header', classes.header)}>
        <h4 className={classnames('modal-title', classes.title)} id="modal-title">
          {gridLabel}
        </h4>
      </div>
      <div className={classnames('modal-body', classes.body)} id="modal-body">
        <div className={classnames('modal-content-wrapper', classes.contentWrapper)}>
          <Grid name={fieldRates} />
        </div>
      </div>
      <div className={classnames('modal-footer', classes.footer)}>
        <Button
          variant="secondary"
          className="btn btn-tertiary popbox-btn1"
          data-key="1"
          onClick={close}
        >
          Close
        </Button>
      </div>
    </form>
  </div>
);

Rates.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  close: PropTypes.func.isRequired,
  commonClasses: PropTypes.string.isRequired,
  fieldRates: PropTypes.string.isRequired,
  gridLabel: PropTypes.string.isRequired,
};

const mapStateToProps = ({ dialogs }) => ({
  fieldRates: dialogs.params.fieldRates,
  gridLabel: dialogs.params.gridLabel,
});

const RatesStyled = withStyles(styles)(Rates);

export default connect(mapStateToProps, { close: dialogActions.close })(RatesStyled);
